<div class="dashboard-container">
  <!-- Header -->
  <app-staff-header [currentUser]="currentUser" (logout)="onLogout()">
  </app-staff-header>

  <!-- Main Content -->
  <div class="dashboard-content">
    <!-- Navigation -->
    <app-staff-nav [isMobileMenuOpen]="isMobileMenuOpen" (navigate)="onNavigate($event)"
      (closeMobileMenu)="closeMobileMenu()">
    </app-staff-nav>

    <!-- Content Area -->
    <div class="dashboard-main">
      <div class="main-content">
        <!-- Page Header -->
        <div class="content-header">
          <h1 class="page-title">จัดการหน่วยงาน</h1>
          <p class="page-subtitle">ระบบจัดการข้อมูลหน่วยงาน VAT</p>
        </div>

        <!-- Mock Data Warning -->
        <ngb-alert *ngIf="showMockDataWarning" type="info" [dismissible]="false" class="mb-3">
          <strong>ข้อมูลตัวอย่าง:</strong>
          ระบบกำลังใช้ข้อมูลตัวอย่างเนื่องจากไม่สามารถเชื่อมต่อ backend API ได้
        </ngb-alert>

        <!-- Error Alert -->
        <ngb-alert *ngIf="error" type="danger" [dismissible]="true" class="mb-3">
          {{ error }}
        </ngb-alert>

        <!-- Filters Section -->
        <div class="filters-section">
          <div class="filters-header">
            <h3>ตัวกรอง</h3>
            <button type="button" class="clear-filters-btn" (click)="clearFilters()">
              ล้างตัวกรอง
            </button>
          </div>

          <div class="filters-grid">
            <!-- Search Term -->
            <div class="filter-group">
              <label class="form-label">ค้นหาทั่วไป</label>
              <input type="text" class="form-control" [(ngModel)]="filters.searchTerm" (ngModelChange)="applyFilters()"
                placeholder="ค้นหาชื่อหน่วยงาน">
            </div>

            <!-- Organization Type -->
            <div class="filter-group">
              <label class="form-label">ประเภทหน่วยงาน</label>
              <select class="form-select" [(ngModel)]="filters.organizationType" (ngModelChange)="applyFilters()">
                <option value="">ทั้งหมด</option>
                <option value="บริษัทประเมินมูลค่าทรัพย์สิน">บริษัทประเมินมูลค่าทรัพย์สิน</option>
                <option value="ธนาคาร/สถาบันการเงิน">ธนาคาร/สถาบันการเงิน</option>
                <option value="หน่วยงานราชการ">หน่วยงานราชการ</option>
                <option value="อื่นๆ">อื่นๆ</option>
              </select>
            </div>

            <!-- Membership Status -->
            <div class="filter-group">
              <label class="form-label">สมาชิกสมทบ</label>
              <select class="form-select" [(ngModel)]="filters.membershipStatus" (ngModelChange)="applyFilters()">
                <option value="">ทั้งหมด</option>
                <option value="YES">YES</option>
                <option value="NO">NO</option>
              </select>
            </div>

            <!-- Status -->
            <div class="filter-group">
              <label class="form-label">สถานะ</label>
              <select class="form-select" [(ngModel)]="filters.status" (ngModelChange)="applyFilters()">
                <option value="all">ทั้งหมด</option>
                <option value="active">เปิดใช้งาน</option>
                <option value="inactive">ปิดใช้งาน</option>
              </select>
            </div>

          </div>

          <!-- Action Buttons -->
          <div class="d-flex gap-2 mt-3">
            <button type="button" class="btn btn-success" (click)="createNewOrganization()">
              <i class="bi bi-building-add me-2"></i>เพิ่มหน่วยงาน
            </button>
            <button type="button" class="btn btn-primary" (click)="loadOrganizations()">
              <i class="bi bi-arrow-clockwise me-2"></i>รีเฟรชข้อมูล
            </button>
          </div>
        </div>

        <!-- Loading Spinner -->
        <div *ngIf="isLoading" class="organization-management-container">
          <div class="loading-state">
            <div class="loading-spinner"></div>
            <p>กำลังโหลดข้อมูลหน่วยงาน...</p>
          </div>
        </div>

        <!-- Organizations Table -->
        <div class="card" *ngIf="!isLoading">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">รายการหน่วยงาน</h5>
            <div class="d-flex align-items-center gap-2">
              <span class="text-muted">แสดงผล:</span>
              <select class="form-select form-select-sm w-auto" [(ngModel)]="pageSize"
                  (ngModelChange)="changePageSize(pageSize)" aria-label="จำนวนรายการต่อหน้า">
                  <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} รายการ</option>
                </select>
            </div>
          </div>

          <div class="card-body p-0">
            <!-- Table -->
            <div class="table-responsive">
              <table class="table table-striped table-hover mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col" class="sortable" (click)="sortBy('id')">
                      ลำดับ {{ getSortIcon('id') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('organizationName')">
                      ชื่อหน่วยงาน {{ getSortIcon('organizationName') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('organizationType')">
                      ประเภทหน่วยงาน {{ getSortIcon('organizationType') }}
                    </th>
                    <th scope="col">อีเมล์</th>
                    <th scope="col">โทร</th>
                    <th scope="col" class="text-center sortable" (click)="sortBy('memberCount')">
                      จำนวนสมาชิก VAT {{ getSortIcon('memberCount') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('membershipStatus')">
                      สมาชิกสมทบ {{ getSortIcon('membershipStatus') }}
                    </th>
                    <th scope="col" class="text-center">ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- No Data Row -->
                  <tr *ngIf="!isLoading && getCurrentPageOrganizations().length === 0">
                    <td colspan="9" class="text-center py-4">
                      <div class="text-muted">
                        <i class="bi bi-building"></i>
                        <p class="mb-0">ไม่พบข้อมูลหน่วยงาน</p>
                        <small *ngIf="organizations.length === 0">ไม่มีข้อมูลในระบบ</small>
                        <small
                          *ngIf="organizations.length > 0 && filteredOrganizations.length === 0">ไม่พบข้อมูลที่ตรงกับเงื่อนไขการกรอง</small>
                      </div>
                    </td>
                  </tr>

                  <!-- Organization Rows -->
                  <tr
                    *ngFor="let organization of getCurrentPageOrganizations(); trackBy: trackByOrganizationId; let i = index"
                    class="clickable-row" title="คลิกเพื่อดูรายละเอียดหน่วยงาน">
                    <!-- Row Number -->
                    <td>{{ (page - 1) * pageSize + i + 1 }}</td>

                    <!-- Organization Name -->
                    <td>
                      <div class="organization-info">
                        <strong>{{ organization.organizationName }}</strong>
                        <small class="text-muted d-block">
                          สร้างเมื่อ: {{ organization.createdAt }}
                        </small>
                      </div>
                    </td>

                    <!-- Organization Type -->
                    <td>
                      <span class="badge bg-info">{{ organization.organizationType }}</span>
                    </td>

                    <!-- Email -->
                    <td>
                      <small class="text-muted">{{ organization.email || '-' }}</small>
                    </td>

                    <!-- Phone -->
                    <td>
                      <small class="text-muted">{{ organization.officePhone || '-' }}</small>
                    </td>

                    <!-- VAT Member Count -->
                    <td class="text-center">
                      <span class="badge bg-secondary">{{ organization.memberCount || 0 }}</span>
                    </td>

                    <!-- Membership Status -->
                    <td class="text-center">
                      <span class="badge" [class.bg-success]="organization.membershipStatus === 'YES'"
                        [class.bg-danger]="organization.membershipStatus === 'NO'">
                        {{ organization.membershipStatus }}
                      </span>
                    </td>

                    <!-- Actions -->
                    <td class="text-center">
                      <div class="action-buttons">
                        <button type="button" class="btn btn-sm btn-primary me-1"
                          (click)="editOrganization(organization); $event.stopPropagation()" title="แก้ไข">
                          EDIT
                        </button>
                        <!-- <span class="text-muted">/</span> -->
                        <!-- <button type="button" class="btn btn-sm btn-danger ms-1"
                          (click)="deleteOrganization(organization); $event.stopPropagation()" title="ลบ">
                          DELETE
                        </button> -->
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Pagination -->
          <div class="card-footer">
            <div class="d-flex justify-content-between align-items-center">
              <div class="text-muted">
                แสดงผล {{ ((page - 1) * pageSize) + 1 }} - {{ min(page * pageSize, collectionSize) }}
                จาก {{ collectionSize }} รายการ
              </div>
              <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="collectionSize" [maxSize]="5"
                [rotate]="true" [boundaryLinks]="true" [size]="'sm'">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>